export const fonts = {
  family: 'Poppins',
};

export const colors = {
  primaryLightBlue: '#3156FF',
  primary: '#002169',
  deepBlue: '#002169',
};
